import "./component-library95.mjs";
import normalizeComponent from "./component-library82.mjs";
const _sfc_main = {
  name: "Price",
  props: {
    amount: { type: String, default: "" },
    isHighlight: { type: Boolean },
    isPriceBold: { type: Boolean },
    isWasPrice: { type: Boolean },
    preText: { type: String, default: "" },
    postText: { type: String, default: "" },
    theme: {
      type: String,
      default: void 0,
      validator(value) {
        return ["light", "dark", "default", void 0].includes(value);
      }
    },
    variant: {
      type: String,
      default: "medium",
      validator(value) {
        return ["small", "medium", "large"].includes(value);
      }
    }
  },
  computed: {
    classes() {
      const modifier = [];
      if (this.theme) {
        modifier.push(`price--${this.theme}`);
      }
      modifier.push(`price--variant-${this.variant}`);
      return modifier;
    },
    preTextClasses() {
      const modifier = [];
      if (this.theme)
        modifier.push(`price__amount--${this.theme}`);
      if (this.isHighlight)
        modifier.push("price__pre-text--highlight");
      return modifier;
    },
    priceClasses() {
      const modifier = [];
      if (this.theme)
        modifier.push(`price__amount--${this.theme}`);
      if (this.isWasPrice)
        modifier.push("price__amount--was-price");
      if (this.isHighlight)
        modifier.push("price__amount--highlight");
      if (this.isPriceBold)
        modifier.push("price__amount--bold");
      return modifier;
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("span", { staticClass: "price", class: _vm.classes }, [_vm.preText ? _c("span", { staticClass: "price__pre-text", class: _vm.preTextClasses, domProps: { "innerHTML": _vm._s(_vm.preText) } }) : _vm._e(), _c("span", { staticClass: "price__amount", class: _vm.priceClasses }, [_vm._v(" " + _vm._s(_vm.amount) + " ")]), _vm.postText ? _c("span", { staticClass: "price__post-text", domProps: { "innerHTML": _vm._s(_vm.postText) } }) : _vm._e()]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "d174b708",
  null,
  null
);
const Price = __component__.exports;
export {
  Price as default
};
